const pending = new Set<AbortController>();
const cancelled = new WeakSet<AbortController>();
export function cancelTokenRequests() {
	pending.forEach((controller) => {
		cancelled.add(controller);
		controller.abort();
	});
}
export async function requestToken(endpoint: string, body: object) {
	const controller = new AbortController();
	pending.add(controller);
	const timer = setTimeout(() => controller.abort(), 30000);
	try {
		const response = await fetch(endpoint, {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify(body),
			signal: controller.signal,
		});
		const data = await response.json();
		if (
			!response.ok ||
			data.error ||
			typeof data.token !== 'string' ||
			!data.token.trim()
		) {
			const ended =
				data.code === 'ROOM_ENDED' ||
				data.message === 'Video chat has ended';
			const passcodeMessage =
				data.error?.message === 'passcode expired'
					? 'Passcode has expired'
					: data.error?.message === 'passcode incorrect'
						? 'Passcode is incorrect'
						: undefined;
			const error = new Error(
				ended
					? 'This video chat has ended.'
					: passcodeMessage ||
							'Unable to join the call. Please try again.',
			);
			error.name = ended ? 'RoomEndedError' : 'JoinError';
			throw error;
		}
		return data;
	} catch (error) {
		if (cancelled.has(controller)) {
			const cancellation = new Error('Joining cancelled.');
			cancellation.name = 'AbortError';
			throw cancellation;
		}
		if (
			error instanceof Error &&
			['RoomEndedError', 'JoinError'].includes(error.name)
		)
			throw error;
		throw new Error(
			'Unable to reach the call. Check your connection and try again.',
		);
	} finally {
		clearTimeout(timer);
		pending.delete(controller);
	}
}
